export type PopoverSide = 'bottom' | 'top';

/**
 * Picks the vertical side with the most viewport space relative to `trigger`, so a popover opens
 * toward — and stays on — whichever side has room, instead of auto-flipping as its content's
 * height changes while open (e.g. a calendar's 5- vs 6-row months, or a filtered combobox list).
 *
 * Call once, at open time (e.g. in `onOpenChange`'s `open` branch), and pin the result via the
 * `side` prop on `PopoverContent` — do not recompute while the popover stays open.
 */
export function computePopoverSide(trigger: HTMLElement | null): PopoverSide {
  if (!trigger) return 'bottom';
  const rect = trigger.getBoundingClientRect();
  const spaceAbove = rect.top;
  const spaceBelow = window.innerHeight - rect.bottom;
  return spaceAbove > spaceBelow ? 'top' : 'bottom';
}
